import {
  GET_ADMIN_PROFILE_URL,
  GET_INSTITUTION_PROFILE_URL,
  UPDATE_ADMIN_PROFILE_URL,
  UPDATE_INSTITUTION_PROFILE_URL,
  CHANGE_ADMIN_PASSWORD_URL,
  CHANGE_INSTITUTION_PASSWORD_URL,
} from "../apiurls/apiurls";

export const getAdminProfile = async (token) => {
  const url = GET_ADMIN_PROFILE_URL;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const getInstitutionProfile = async (token) => {
  const url = GET_INSTITUTION_PROFILE_URL;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const updateAdminProfile = async (token, payload) => {
  const url = UPDATE_ADMIN_PROFILE_URL;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const updateInstitutionProfile = async (token, payload) => {
  const url = UPDATE_INSTITUTION_PROFILE_URL;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const changeAdminPassword = async (token, payload) => {
  const url = CHANGE_ADMIN_PASSWORD_URL;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const changeInstitutionPassword = async (token, payload) => {
  const url = CHANGE_INSTITUTION_PASSWORD_URL;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};
